(function () {

  'use strict';

  angular.module('Home')
    .controller('HomeController', function (
      $rootScope, $scope, URLS, $location, TenantListService, toastr,
      $filter, MetricListService, PrinterListService, PrinterListPOSTPaging,
      EventHandlerService, UserListService, UserListPaging, CopilotService) {

      $scope.TenantListService = TenantListService;
      $scope.CopilotService = CopilotService;
      $scope.Math = Math;

      $scope.urls = URLS;
      $scope.metric = null;
      $scope.printActivityClean = {
        data: [
          []
        ],
        labels: []
      };
      $scope.printActivityTotal = angular.copy($scope.printActivityClean);
      $scope.printActivityColor = angular.copy($scope.printActivityClean);
      $scope.printActivityDuplex = angular.copy($scope.printActivityClean);
      $scope.printActivityFollowMe = angular.copy($scope.printActivityClean);
      $scope.timeIntervalList = [
        {
          value: 7,
          translateKey: 'LastDays',
          translateParameter: 7
        },
        {
          value: 14,
          translateKey: 'LastDays',
          translateParameter: 14
        },
        {
          value: 28,
          translateKey: 'LastWeeks',
          translateParameter: 4
        }
      ];
      $scope.selectedTimeInterval = $scope.timeIntervalList[0];
      $scope.helpCaption = 'HelpDashboard';
      $scope.printersUnderCreationTotalNumber = 0;
      $scope.users = 0;
      $scope.guestUsers = 0;

      $scope.optionsPrintActivityTotal = {
        tooltips: {
          callbacks: {
            title: function () {
              return '';
            },
            label: function (tooltipItem, data) {
              const value = $scope.printActivityTotal.data[0][tooltipItem.index];
              const label = $scope.printActivityTotal.labels[tooltipItem.index];
              return ' ' + value + ' ' + $filter('translate')('Pages') + ' - ' + label;
            }
          }
        }
      };

      $scope.optionsPrintActivityColor = {
        tooltips: {
          callbacks: {
            title: function () {
              return '';
            },
            label: function (tooltipItem, data) {
              const value = Math.round($scope.printActivityColor.data[0][tooltipItem.index]);
              const label = $scope.printActivityColor.labels[tooltipItem.index];
              return ' ' + value + '% - ' + label;
            }
          }
        }
      };

      $scope.optionsPrintActivityDuplex = {
        tooltips: {
          callbacks: {
            title: function () {
              return '';
            },
            label: function (tooltipItem, data) {
              const value = Math.round($scope.printActivityDuplex.data[0][tooltipItem.index]);
              const label = $scope.printActivityDuplex.labels[tooltipItem.index];
              return ' ' + value + '% - ' + label;
            }
          }
        }
      };

      $scope.optionsPrintActivityFollowMe = {
        tooltips: {
          callbacks: {
            title: function () {
              return '';
            },
            label: function (tooltipItem, data) {
              const value = Math.round($scope.printActivityFollowMe.data[0][tooltipItem.index]);
              const label = $scope.printActivityFollowMe.labels[tooltipItem.index];
              return ' ' + value + '% - ' + label;
            }
          }
        }
      };

      $scope.openSettingsPage = function () {
        $location.hash('software');
        $location.path(URLS.SOFTWARE_DISTRIBUTION_PAGE);
      };

      $scope.changeMetricTimeInterval = function (interval) {
        if (interval) {
          $scope.selectedTimeInterval = interval;
        }
        $scope.metric = null;
        MetricListService.getMetric($scope.selectedTimeInterval.value)
          .then(function () {
            $scope.metric = MetricListService.metricModel;
            $scope.printActivityTotal = angular.copy($scope.printActivityClean);
            $scope.printActivityColor = angular.copy($scope.printActivityClean);
            $scope.printActivityDuplex = angular.copy($scope.printActivityClean);
            $scope.printActivityFollowMe = angular.copy($scope.printActivityClean);
            angular.forEach($scope.metric.timedData, function (datePoint) {
              $scope.printActivityTotal.data[0].add(datePoint.totalPages, true);
              $scope.printActivityTotal.labels.add($filter('date')(new Date(datePoint.time), 'MMM dd'));
              $scope.printActivityColor.data[0].add(datePoint.colorMonoRatio.ratio, true);
              $scope.printActivityColor.labels.add($filter('date')(new Date(datePoint.time), 'MMM dd'));
              $scope.printActivityDuplex.data[0].add(datePoint.duplexSimplexRatio.ratio, true);
              $scope.printActivityDuplex.labels.add($filter('date')(new Date(datePoint.time), 'MMM dd'));
              $scope.printActivityFollowMe.data[0].add(datePoint.nowLaterRatio.ratio, true);
              $scope.printActivityFollowMe.labels.add($filter('date')(new Date(datePoint.time), 'MMM dd'));
            });
          })
          .catch(function () {
          });
      };

      $scope.copyToClipboard = function (text) {
        if (text) {
          navigator.clipboard.writeText(text)
            .then(function () {
              toastr.success($filter('translate')('CopyToClipboard'));
            })
            .catch(function () {
            });
        }
      };

      const deregisterWatch = $rootScope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser && $rootScope.currentUser.info) {
          $scope.changeMetricTimeInterval();
          getPrinterUnderCreationListPaged();
          getPrinterListPaged();
          getUsers();
          getGuestUsers();
          deregisterWatch();
        }
      }, true);

      (function () {
        EventHandlerService.deRegisterListeners();
      })();

      function getUsers() {
        const userListPaging = new UserListPaging();
        userListPaging.pagingCriteria.pageSize = 1;
        UserListService.getUserListPaged(userListPaging)
          .then(function (userContainer) {
            $scope.users = userContainer.page.totalElements;
          })
          .catch(function () {
          });
      }

      function getGuestUsers() {
        const userListPaging = new UserListPaging();
        userListPaging.pagingCriteria.pageSize = 1;
        userListPaging.pagingCriteria.roles = 'GUEST_USER';
        UserListService.getUserListPaged(userListPaging)
          .then(function (userContainer) {
            $scope.guestUsers = userContainer.page.totalElements;
          })
          .catch(function () {
          });
      }

      function getPrinterListPaged() {
        const printerListPaging = new PrinterListPOSTPaging();
        printerListPaging.pagingCriteria.pageSize = 1;
        printerListPaging.pagingCriteria.types = 'VIRTUAL,NETWORK';
        PrinterListService.getPrinterListPaged(printerListPaging)
          .then(function (printerContainer) {
            $scope.printerContainer = printerContainer;
          })
          .catch(function () {
          });
      }

      function getPrinterUnderCreationListPaged() {
        const printerListPaging = new PrinterListPOSTPaging();
        printerListPaging.pagingCriteria.pageSize = 1;
        printerListPaging.pagingCriteria.underCreation = true;
        PrinterListService.getPrinterListPaged(printerListPaging)
          .then(function (printerListObject) {
            $scope.printersUnderCreationTotalNumber = printerListObject.page.totalElements;
          })
          .catch(function () {
          });
      }

    });

})();
